import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


@Injectable({
  providedIn: 'root'
})

export class LayoutService {
  isInSm: boolean = false;
  isInMd: boolean = false;
  isInLg: boolean = false;
  isInXl: boolean = false;

  /* test UI, can be removed */

  // isLogin:boolean = false;

  isPlaying: boolean = false;
  // isOpenPDF:boolean = false;

  autoScrolling: boolean = false;

  maxUpload: boolean = true;

  showUpload: boolean = false;

  /* test UI, can be removed */



  constructor(
    public breakpointObserver: BreakpointObserver
  ) {
    breakpointObserver.observe([
      '(min-width: 992px)'
    ]).subscribe(result => {
      this.isInXl = result["matches"];
    });
    breakpointObserver.observe([
      '(max-width: 991px)'
    ]).subscribe(result => {
      this.isInLg = result["matches"];
    });
    breakpointObserver.observe([
      '(max-width: 767px)',
      '(max-width: 900px) and (max-height: 575px) and (orientation: landscape)',
    ]).subscribe(result => {
      this.isInMd = result["matches"];
    });
    breakpointObserver.observe([
      '(max-width: 575px)',
      '(max-width: 900px) and (max-height: 575px) and (orientation: landscape)',
      Breakpoints.HandsetLandscape,
    ]).subscribe(result => {
      this.isInSm = result["matches"];
      this.maxUpload = true;
    });
  }

}
